export const rollbarConfig = {
  accessToken: process.env.GATSBY_ROLLBAR_ACCESS_KEY,
  environment: process.env.NODE_ENV || "development",
  scrubTelemetryInputs: true,
  enabled: !!process.env.GATSBY_ROLLBAR_ACCESS_KEY,
  captureUncaught: true,
  captureUnhandledRejections: true,
};
